import { fetchHelper } from '@price-point/http-helpers';

export default function onSubmitForgotPassword(username) {
  return async () => {
    await fetchHelper('na', 'POST', '/api/v1/oidc/sendResetEmail', { username });
  };
}
